export default __webpack_public_path__ + "bc2785270ed257f9b26550faedcafe4b.jpg";